import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MarketingCard from "./MarketingCard";
import { marketingData } from "./marketingData";
import "./MarketingServices.css";
import {
  FaRocket,
  FaBullseye,
  FaUsers,
  FaChartLine,
  FaNewspaper,
  FaGlobe,
  FaStar,
  FaBolt,
  FaShieldAlt,
  FaCog,
  FaHashtag,
  FaRegCalendarAlt,
  FaComments,
  FaMicrophone,
  FaParachuteBox,
  FaHandshake,
  FaMoneyBill,
  FaFileAlt,
  FaFileContract,
  FaChartBar,
  FaExchangeAlt,
  FaPaintBrush,
  FaPalette,
  FaThumbsUp,
  FaMedal,
  FaLightbulb,
  FaLink,
  FaSearch,
  FaWrench,
  FaCheckCircle,
  FaLayerGroup,
  FaCode,
  FaTasks,
  FaCoins,
  FaRegChartBar,
  FaBroadcastTower,
  FaHandHoldingUsd,
  FaRegHandshake,
  FaTimes,
  FaPenFancy,
  FaChess,
  FaBullhorn,
  FaPeopleArrows,
  FaFilePowerpoint,
} from "react-icons/fa";

const MarketingServiceDetail = ({ service }) => {
  const navigate = useNavigate();
  const relatedServices = marketingData
    .filter((s) => s.id !== service.id)
    .sort(() => 0.5 - Math.random())
    .slice(0, 3);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [service]);

  if (!service) return null;

  // Smart icon matching based on feature text keywords
  const getFeatureIcon = (featureText) => {
    const text = featureText.toLowerCase();
    if (
      text.includes("launch") ||
      text.includes("strategy") ||
      text.includes("go-to-market")
    )
      return <FaRocket size={30} />;
    if (
      text.includes("awareness") ||
      text.includes("campaign") ||
      text.includes("multi-platform")
    )
      return <FaBullseye size={30} />;
    if (
      text.includes("community") ||
      text.includes("discord") ||
      text.includes("telegram")
    )
      return <FaUsers size={30} />;
    if (
      text.includes("investor") ||
      text.includes("outreach") ||
      text.includes("fundraising")
    )
      return <FaHandHoldingUsd size={30} />;
    if (
      text.includes("press") ||
      text.includes("media") ||
      text.includes("publication")
    )
      return <FaNewspaper size={30} />;
    if (
      text.includes("global") ||
      text.includes("international") ||
      text.includes("pr")
    )
      return <FaGlobe size={30} />;
    if (
      text.includes("brand") ||
      text.includes("storytelling") ||
      text.includes("narrative")
    )
      return <FaMicrophone size={30} />;
    if (
      text.includes("growth") ||
      text.includes("funnel") ||
      text.includes("audience")
    )
      return <FaChartLine size={30} />;
    if (
      text.includes("analytics") ||
      text.includes("data") ||
      text.includes("performance")
    )
      return <FaChartBar size={30} />;
    if (
      text.includes("planning") ||
      text.includes("roadmap") ||
      text.includes("targeting")
    )
      return <FaRegCalendarAlt size={30} />;
    if (
      text.includes("content") ||
      text.includes("scheduling") ||
      text.includes("posting")
    )
      return <FaRegCalendarAlt size={30} />;
    if (
      text.includes("engagement") ||
      text.includes("interaction") ||
      text.includes("daily")
    )
      return <FaComments size={30} />;
    if (
      text.includes("voice") ||
      text.includes("development") ||
      text.includes("creation")
    )
      return <FaPalette size={30} />;
    if (
      text.includes("influencer") ||
      text.includes("sponsored") ||
      text.includes("promotion")
    )
      return <FaStar size={30} />;
    if (
      text.includes("identification") ||
      text.includes("outreach") ||
      text.includes("negotiation")
    )
      return <FaSearch size={30} />;
    if (
      text.includes("airdrop") ||
      text.includes("token distribution") ||
      text.includes("task")
    )
      return <FaParachuteBox size={30} />;
    if (text.includes("onboarding") || text.includes("user"))
      return <FaHandshake size={30} />;
    if (text.includes("nft") || text.includes("dao") || text.includes("web3"))
      return <FaLayerGroup size={30} />;
    if (
      text.includes("hacking") ||
      text.includes("hack") ||
      text.includes("growth hacking")
    )
      return <FaBolt size={30} />;
    if (
      text.includes("blog") ||
      text.includes("article") ||
      text.includes("whitepaper")
    )
      return <FaFileAlt size={30} />;
    if (
      text.includes("document") ||
      text.includes("educational") ||
      text.includes("documentation")
    )
      return <FaFileContract size={30} />;
    if (
      text.includes("social") ||
      text.includes("hashtag") ||
      text.includes("twitter")
    )
      return <FaHashtag size={30} />;
    if (
      text.includes("rebrand") ||
      text.includes("identity") ||
      text.includes("visual")
    )
      return <FaPaintBrush size={30} />;
    if (
      text.includes("messaging") ||
      text.includes("positioning") ||
      text.includes("refinement")
    )
      return <FaBroadcastTower size={30} />;
    if (
      text.includes("pitch") ||
      text.includes("deck") ||
      text.includes("presentation")
    )
      return <FaFileContract size={30} />;
    if (text.includes("slide") || text.includes("visual story"))
      return <FaThumbsUp size={30} />;
    if (
      text.includes("tokenomics") ||
      text.includes("token") ||
      text.includes("coin")
    )
      return <FaCoins size={30} />;
    if (text.includes("exchange") || text.includes("listing"))
      return <FaExchangeAlt size={30} />;
    if (
      text.includes("compliance") ||
      text.includes("legal") ||
      text.includes("technical")
    )
      return <FaShieldAlt size={30} />;
    if (
      text.includes("integration") ||
      text.includes("api") ||
      text.includes("documentation")
    )
      return <FaCode size={30} />;
    if (text.includes("moderation") || text.includes("management"))
      return <FaTasks size={30} />;
    if (
      text.includes("verification") ||
      text.includes("approval") ||
      text.includes("application")
    )
      return <FaCheckCircle size={30} />;
    if (
      text.includes("roi") ||
      text.includes("results") ||
      text.includes("metric")
    )
      return <FaRegChartBar size={30} />;
    return <FaRegHandshake size={30} />; // fallback
  };

  const getBenefitIcon = (text) => {
    const t = text.toLowerCase();

    if (t.includes("visibility") || t.includes("exposure"))
      return <FaGlobe size={25} />;
    if (t.includes("trust") || t.includes("credibility"))
      return <FaShieldAlt size={25} />;
    if (t.includes("engagement")) return <FaComments size={25} />;
    if (t.includes("growth") || t.includes("adoption"))
      return <FaChartLine size={25} />;
    if (t.includes("roi") || t.includes("performance"))
      return <FaChartBar size={25} />;
    if (t.includes("community") || t.includes("user"))
      return <FaUsers size={25} />;
    if (t.includes("launch")) return <FaRocket size={25} />;
    if (t.includes("brand") || t.includes("authority"))
      return <FaMedal size={25} />;
    if (t.includes("seo") || t.includes("search"))
      return <FaSearch size={25} />;
    if (t.includes("fund") || t.includes("investor"))
      return <FaHandHoldingUsd size={25} />;
    if (t.includes("liquidity") || t.includes("trading"))
      return <FaExchangeAlt size={25} />;

    return <FaCheckCircle size={25} />; // fallback
  };

  return (
    <div className="ms-detail">
      {/* Cover */}
      <div
        className="ms-detail-cover"
        style={{
          background: `linear-gradient(135deg, ${service.accentColor}dd 0%, ${service.accentColor}88 50%, ${service.accentColor}44 100%)`,
        }}
      />

      <div className="ms-container">
        {/* Header */}
        <div className="ms-detail-header">
          <div className="ms-detail-header-left">
            <div className="ms-detail-icon-box">
              <service.icon
                style={{ color: service.accentColor, fontSize: "50px" }}
              />
            </div>

            <div className="ms-detail-info">
              <div className="ms-detail-tags">
                <span
                  className="ms-category-tag"
                  style={{
                    border: `1px solid ${service.accentColor}20`,
                    background: `${service.accentColor}10`,
                  }}
                >
                  {service.category}
                </span>
              </div>

              <h1 className="ms-detail-title">{service.title}</h1>
              <p className="ms-detail-subtitle">{service.subtitle}</p>

              <div className="ms-detail-meta">
                <span className="ms-detail-status">● Available</span>
              </div>
            </div>
          </div>

          <div className="ms-detail-header-actions">
            <button
              className="ms-close-btn"
              onClick={() => navigate("/marketing")}
            >
              <FaTimes size={18} />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="ms-detail-body">
          <div className="ms-detail-main">
            {/* Description */}
            <section className="ms-detail-section">
              <h2 className="ms-detail-section-title">About {service.title}</h2>
              <p className="ms-detail-section-text">
                {service.detailedDescription}
              </p>
            </section>

            {/* Features Grid */}
            <section className="ms-detail-section">
              <h2 className="ms-detail-section-title">What We Offer</h2>
              <div className="ms-features-grid">
                {service.features.map((feature, idx) => (
                  <div key={idx} className="ms-feature-card">
                    <div
                      className="ms-feature-card-icon"
                      style={{
                        background: `${service.accentColor}12`,
                        color: service.accentColor,
                      }}
                    >
                      {getFeatureIcon(feature)}
                    </div>
                    <h4>{feature}</h4>
                  </div>
                ))}
              </div>
            </section>
            {service.process && (
              <section className="ms-detail-section">
                <h2 className="ms-detail-section-title">Our Process</h2>

                {service.process.map((para, idx) => (
                  <p key={idx} className="ms-process-paragraph">
                    {para}
                  </p>
                ))}
              </section>
            )}

            {/* Benefits */}
            {service.benefits && (
              <section className="ms-detail-section">
                <h2 className="ms-detail-section-title">Key Benefits</h2>
                <ul className="ms-benefits-list">
                  {service.benefits.map((benefit, idx) => (
                    <li key={idx} className="ms-benefit-item">
                      <div
                        className="ms-benefit-icon"
                        style={{
                          color: service.accentColor,
                          fontSize: "16px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {getBenefitIcon(benefit)}
                      </div>
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>
              </section>
            )}

            {/* Tools */}
            {service.tools && (
              <section className="ms-detail-section">
                <h2
                  className="ms-detail-section-title"
                  style={{
                    fontSize: "13px",
                    color: "#64748b",
                    textTransform: "uppercase",
                    letterSpacing: "0.15em",
                    fontWeight: 700,
                  }}
                >
                  Tools & Platforms
                </h2>
                <div className="ms-tools-grid">
                  {service.tools.map((tool, idx) => (
                    <span key={idx} className="ms-tool-pill">
                      {tool}
                    </span>
                  ))}
                </div>
              </section>
            )}
          </div>

          {/* Sidebar */}
          <aside>
            <div className="ms-detail-sidebar-cta">
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "16px",
                  background: `${service.accentColor}12`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  border: `1px solid ${service.accentColor}20`,
                }}
              >
                <service.icon
                  style={{ color: service.accentColor, fontSize: "24px" }}
                />
              </div>
              <h3>Ready to boost your project with {service.title}?</h3>
              <div className="ms-contact-buttons justify-content-center">
                <a
                  href="https://wa.me/+917383847632"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ms-cta-btn ms-cta-whatsapp"
                >
                  <i className="fab fa-whatsapp" /> WhatsApp
                </a>
                <a
                  href="https://t.me/Xeertechnology"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ms-cta-btn ms-cta-telegram"
                >
                  <i className="fab fa-telegram-plane" /> Telegram
                </a>
              </div>
            </div>

            {/* Quick Stats */}
            <div
              className="ms-detail-sidebar-cta"
              style={{ marginTop: "20px" }}
            >
              <h3 style={{ fontSize: "14px", marginBottom: "16px" }}>
                Quick Stats
              </h3>
              {[
                {
                  label: "Features",
                  value: service.features?.length || 0,
                  icon: "fas fa-star",
                },
                {
                  label: "Process Steps",
                  value: service.process?.length || 0,
                  icon: "fas fa-list-ol",
                },
                {
                  label: "Tools Used",
                  value: service.tools?.length || 0,
                  icon: "fas fa-wrench",
                },
              ].map((stat, idx) => (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px 0",
                    borderBottom:
                      idx < 2 ? `1px solid var(--ms-border)` : "none",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <i
                      className={stat.icon}
                      style={{ color: "#94a3b8", fontSize: "12px" }}
                    />
                    <span
                      style={{
                        color: "var(--ms-paragraph)",
                        fontSize: "13px",
                      }}
                    >
                      {stat.label}
                    </span>
                  </div>
                  <span
                    style={{
                      fontWeight: 700,
                      color: "var(--ms-heading)",
                      fontSize: "14px",
                    }}
                  >
                    {stat.value}
                  </span>
                </div>
              ))}
            </div>
          </aside>
        </div>

        {/* Related Services */}
        <div className="ms-related-section">
          <div style={{ marginBottom: "36px" }}>
            <h2>Explore Related Services</h2>
            <p>
              Discover other marketing solutions that complement {service.title}
              .
            </p>
          </div>

          <div className="ms-grid">
            {relatedServices.map((relService, idx) => (
              <MarketingCard
                key={relService.id}
                service={relService}
                index={idx}
                onClick={(s) => navigate(`/marketing/${s.id}`)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketingServiceDetail;
